(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alliance-about-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-about-story')) {
    customElements.define('ap-about-story', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const lab = this.querySelector('.ap-story__lab');
        if (lab) {
          this.querySelector('.ap-story__controls').hidden = false;
          this.addEventListener('click', event => {
            const button = event.target.closest('[data-peptide-state]');
            if (!button || !this.contains(button)) return;
            lab.dataset.state = button.dataset.peptideState;
            this.querySelectorAll('[data-peptide-state]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            this.querySelectorAll('[data-caption]').forEach(item => { item.hidden = item.dataset.caption !== button.dataset.peptideState; });
          }, { signal:this.controller.signal });
        }
        if (this.dataset.kind === 'approach' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('ap-story--observed');
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.classList.add('ap-story--seen');
              this.observer.disconnect();
            }
          }, { threshold:0.15 });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alliance-science-library"]) return;
  try {
    
function initScienceLibrary(root = document) {
 root.querySelectorAll('.sc-filter').forEach(filter => {
  if (filter.dataset.ready) return;
  filter.dataset.ready = 'true'; filter.hidden = false;
  const select = filter.querySelector('select');
  select.addEventListener('change', () => {
   filter.closest('.sc-page').querySelectorAll('.sc-reference').forEach(card => { card.hidden = select.value !== 'all' && card.dataset.source !== select.value; });
  });
 });
}
initScienceLibrary();
document.addEventListener('shopify:section:load', () => initScienceLibrary());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alliance-scientific-council"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-scientific-council')) {
    customElements.define('ap-scientific-council', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ap-council__track');
        this.previous = this.querySelector('[data-council-previous]');
        this.next = this.querySelector('[data-council-next]');
        if (!this.track || !this.previous || !this.next) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          this.previous.disabled = this.track.scrollLeft < 2;
          this.next.disabled = this.track.scrollLeft >= max - 2;
        };
        const move = direction => {
          const card = this.track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = card.getBoundingClientRect().width + gap;
          this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-editorial-hero"] && !Shopify.designMode) return;
  try {
    
function configureHeroVideo(root) {
  root.querySelectorAll('.md-video-hero__video').forEach(video => {
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    const button = video.closest('.md-video-hero__film').querySelector('.sig-video-toggle');
    if (button && !button.dataset.ready) {
      button.dataset.ready = 'true'; button.hidden = false;
      const sync = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
      button.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); });
      video.addEventListener('play', sync); video.addEventListener('pause', sync); sync();
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.autoplay = false;
      video.pause();
    } else {
      video.play().catch(() => {});
    }
  });
}
configureHeroVideo(document);
document.addEventListener('shopify:section:load', event => configureHeroVideo(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-journal"] && !Shopify.designMode) return;
  try {
    

function initMdJournal(){document.querySelectorAll('.md-journal').forEach(section=>{
 const track=section.querySelector('.md-journal__track');if(!track||track.dataset.ready)return;track.dataset.ready='true';
 const controls=section.querySelector('.md-journal__controls');const cards=[...track.children];const buttons=[...controls.querySelectorAll('button')];let current=0;
 const update=()=>{const overflowing=track.scrollWidth>track.clientWidth+2;controls.hidden=!overflowing;
 const left=track.getBoundingClientRect().left;current=cards.reduce((best,card,i)=>Math.abs(card.getBoundingClientRect().left-left)<Math.abs(cards[best].getBoundingClientRect().left-left)?i:best,0);
 controls.querySelector('.md-journal__count').textContent=(current+1)+' / '+cards.length;buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
 buttons.forEach(button=>button.addEventListener('click',()=>{const target=cards[Math.max(0,Math.min(cards.length-1,current+Number(button.dataset.direction)))];track.scrollBy({left:target.getBoundingClientRect().left-track.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}));
 track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
 });}
initMdJournal();document.addEventListener('shopify:section:load',initMdJournal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["md-needs-orbit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('md-need-orbit')){
customElements.define('md-need-orbit',class extends HTMLElement{
connectedCallback(){
if(this.controller)return;
this.controller=new AbortController();const signal=this.controller.signal;
this.button=this.querySelector('.md-needs__pause');this.pauseLabel=this.button.textContent;this.resumeLabel=this.querySelector('[data-resume]').textContent;
this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.manual=false;this.hovering=false;this.focused=false;
this.sync=()=>{const enabled=this.dataset.motion==='true'&&!this.reduced.matches;this.button.hidden=!enabled;const paused=!enabled||!this.visible||document.hidden||this.manual||this.hovering||this.focused;this.style.setProperty('--need-play',paused?'paused':'running');this.button.textContent=this.manual?this.resumeLabel:this.pauseLabel;this.button.setAttribute('aria-pressed',String(this.manual));};
this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){this.hovering=true;this.sync();}},{signal});
this.addEventListener('pointerleave',()=>{this.hovering=false;this.sync();},{signal});
this.addEventListener('pointerdown',e=>{if(e.pointerType==='touch'&&e.target.closest('.md-needs__circle')){this.manual=true;this.sync();}},{signal});
this.addEventListener('focusin',e=>{this.focused=!!e.target.closest('.md-needs__circle');this.sync();},{signal});
this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=!!this.querySelector('.md-needs__circle:focus');this.sync();});},{signal});
this.button.addEventListener('click',()=>{this.manual=!this.manual;this.sync();},{signal});
document.addEventListener('visibilitychange',this.sync,{signal});this.reduced.addEventListener('change',this.sync,{signal});
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.1});this.observer.observe(this);this.sync();
}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.controller=null;}
});
}

  } catch(e) { console.error(e); }
})();
})();
